import cx from 'classnames'
import React from 'react'

import { Cross } from '@cinch/oxd-components/icons/src'
import SVG from '@cinch/oxd-components/svg/src'
import tokens from '@cinch/oxd-utils/tokens/src'

interface FilterLozengeProps {
  label: string
  value: string | number
  onRemove?: (value: any) => void
  maxWidth?: boolean
}

import * as styles from './filter-lozenge.module.css'

const FilterLozenge: React.FC<FilterLozengeProps> = ({ label, value, onRemove, maxWidth }) => {
  const removeHandler = () => {
    if (onRemove) {
      onRemove(value)
    }
  }

  return (
    <div className={cx(styles.filterLozenge, { [styles.maxWidth]: maxWidth })} role="listitem">
      <span className={styles.label} title={label} data-testid="lozenge-label">
        {label}
      </span>
      {!!onRemove && (
        <button className={styles.deleteLozenge} type="button" onClick={removeHandler}>
          <SVG children={Cross} size={tokens.customProperties.spacing.s} />
        </button>
      )}
    </div>
  )
}

export default FilterLozenge
